var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',_vm._g(_vm._b({attrs:{"type":_vm.type,"height":_vm.height,"width":_vm.width,"options":_vm.resolvedOptions,"series":_vm.resolvedSeries}},'apexchart',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }